export default __webpack_public_path__ + "static/media/akc-logo-white.4ee90569.svg";